import SuccessErrorMessage from './SuccessErrorMessage';

export default SuccessErrorMessage;
